export interface QueuedEvent {
  name: string
  properties: Record<string, any>
}

export class EventQueue {
  private queue: QueuedEvent[] = []
  private timer: NodeJS.Timeout | null = null
  private batchSize: number
  private batchInterval: number
  private flushCallback: (events: QueuedEvent[]) => void

  constructor(batchSize: number, batchInterval: number, flushCallback: (events: QueuedEvent[]) => void) {
    this.batchSize = batchSize
    this.batchInterval = batchInterval
    this.flushCallback = flushCallback
  }

  public add(name: string, properties: Record<string, any>): void {
    this.queue.push({ name, properties })

    if (this.queue.length >= this.batchSize) {
      this.flush()
    } else if (!this.timer) {
      this.timer = setTimeout(() => this.flush(), this.batchInterval)
    }
  }

  public flush(): void {
    if (this.queue.length > 0) {
      this.flushCallback([...this.queue])
      this.queue = []
    }

    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
  }
}
